import { jsxs as e, jsx as r } from "react/jsx-runtime";
const i = ({
  link: o,
  text: a,
  taggingEvent: c
}) => /* @__PURE__ */ e("div", { className: "product-card-see-more-horizontal", children: [
  /* @__PURE__ */ r("div", { className: "product-card-see-more-horizontal-container", children: /* @__PURE__ */ e("p", { className: "product-card-see-more-text-horizontal", children: [
    "Veja mais ",
    /* @__PURE__ */ r("br", {}),
    /* @__PURE__ */ r("span", { children: a })
  ] }) }),
  /* @__PURE__ */ r(
    "a",
    {
      className: "product-card-see-more-link-horizontal",
      onClick: c,
      href: o,
      children: "Ver mais"
    }
  )
] });
export {
  i as ProductCardSeeMoreHorizontal
};
